import settings from './settings';
import referrals from './referrals';
import subscriptionInvoicePayments from './subscription-invoice-payments';
import subscriptionInvoices from './subscription-invoices';
import subscriptions from './subscriptions';
import apiTokens from './api-tokens';
import invoice from './invoice';

let messages = Object.assign({}, settings, referrals, subscriptionInvoicePayments, subscriptionInvoices, subscriptions, apiTokens, invoice);

export default messages;
